import {
  addDisplayName,
  flowMax,
  branch,
  returns,
  CurriedUnchangedProps,
  addProps,
} from 'ad-hok'
import { branchIfFailsPredicate } from 'ad-hok-utils'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addApi } from 'shared/src/api'
import {
  addDataLoadingFromPromise,
  hasData,
} from 'shared/src/utils/dataLoading'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#F9F6F4',
    height: '100dvh',
  },
  image: {
    maxWidth: 428,
  },
})

interface Props {
  image: string
}

const Maintenance: FC<Props> = flowMax(
  addDisplayName('Maintenance'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ image, classes }) => (
    <div className={classes.container}>
      <img src={image} className={classes.image} alt="We'll be back soon" />
    </div>
  )
)

type AddMaintenancePage = <TProps extends {}>(
  image: string
) => CurriedUnchangedProps<TProps>

export const addMaintenancePage: AddMaintenancePage = (image) =>
  flowMax(
    addApi,
    addDataLoadingFromPromise(
      'isInMaintenanceMode',
      ({ api }) =>
        api
          .getStatus()
          .then((response) => response.status !== 200)
          .catch(() => true),
      []
    ),
    branchIfFailsPredicate('isInMaintenanceMode', hasData),
    branch(
      ({ isInMaintenanceMode }) => isInMaintenanceMode.data,
      returns(() => <Maintenance image={image} />)
    )
  )
